<template>
  <div class="card shadow-sm table-card mb-4">
    <div class="form-card-header flex-wrap">
      <div class="section-number"><i class="fe fe-award" style="font-size: 12px;"></i></div>
      <div class="flex-grow-1">
        <h6 class="mb-0 font-weight-bold text-white">Enrolment performance</h6>
        <small style="color: rgba(255,255,255,.75);">People each staff member enrolled (principals and dependants; dependants count under their principal's programme)</small>
      </div>
      <button v-if="closable" class="btn btn-sm btn-light" @click="$emit('close')"><i class="fe fe-x"></i></button>
    </div>
    <div class="card-body">
      <div class="d-flex flex-wrap align-items-center mb-3" style="gap: 8px;">
        <PeriodPicker v-model="period" @change="load" default-preset="30d" />
        <select class="form-control form-control-sm" style="width: auto;" v-model="jobTitle" @change="load" aria-label="Job title">
          <option value="">All job titles</option>
          <option v-for="t in jobTitles" :key="t" :value="t">{{ t }}</option>
        </select>
        <v-select class="sector-select" multiple v-model="sectors" :options="sectorOptions" placeholder="All programmes"
          input-id="officer-performance-programmes" aria-label="Programme" @input="load" />
        <span v-if="data" class="small text-muted ml-auto">{{ data.total.toLocaleString() }} enrolled by {{ data.staff_count }} staff</span>
      </div>
      <div v-if="loading && !data" class="empty-state"><i class="mdi mdi-loading mdi-spin"></i>Loading…</div>
      <div v-else-if="data && !data.rows.length" class="empty-state">Nobody was enrolled in this period{{ sectors.length ? ' in the chosen programme' + (sectors.length > 1 ? 's' : '') : '' }}.</div>
      <apexchart v-else-if="data" type="bar" :height="Math.max(240, data.rows.length * 30)" :options="options" :series="series" :key="chartKey" />
    </div>
  </div>
</template>

<script>
import PeriodPicker from "./PeriodPicker.vue";

/** Staff ranked by people enrolled (GET analytics/enrollment/officers). */
export default {
  name: "OfficerPerformance",
  components: { PeriodPicker },
  props: { closable: { type: Boolean, default: false } },
  data() {
    return { period: { from: "", to: "" }, jobTitle: "", jobTitles: [], sectors: [], sectorOptions: [], data: null, loading: false, chartKey: 0 };
  },
  computed: {
    series() {
      return [
        { name: "Principals", data: this.data.rows.map((r) => r.principals) },
        { name: "Dependants", data: this.data.rows.map((r) => r.dependants) },
      ];
    },
    options() {
      const rows = this.data.rows;
      return {
        chart: { stacked: true, toolbar: { show: true }, events: { dataPointSelection: (e, ctx, cfg) => {
          const r = rows[cfg.dataPointIndex];
          if (r && r.type === "employee") this.$router.push(`/employee/${r.user_id}`);
        } } },
        colors: ["#2563eb", "#93c5fd"],
        plotOptions: { bar: { horizontal: true, barHeight: "70%", borderRadius: 3 } },
        xaxis: { categories: rows.map((r) => r.name + (r.job_title ? ` (${r.job_title})` : "")), labels: { formatter: (v) => Math.round(v).toLocaleString() } },
        dataLabels: { enabled: true, formatter: (v, o) => (o.seriesIndex === 1 ? rows[o.dataPointIndex].total.toLocaleString() : ""), offsetX: 18, style: { colors: ["#0f172a"] } },
        legend: { position: "top" },
        tooltip: { shared: true, intersect: false },
      };
    },
  },
  mounted() {
    this.$batchGet("/api/v1/auth/analytics/enrollment/sectors").then((res) => {
      this.sectorOptions = (res.data.data.rows || []).map((r) => r.sector);
    }).catch(() => {});
    if (this.period.from) this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$batchGet("/api/v1/auth/analytics/enrollment/officers", { params: { from: this.period.from, to: this.period.to, job_title: this.jobTitle || undefined, sectors: this.sectors } })
        .then((res) => {
          this.data = res.data.data;
          // keep the job-title choices from the unfiltered list (a programme filter can leave some titles out)
          if (!this.jobTitle && !this.sectors.length) this.jobTitles = this.data.job_titles;
          this.chartKey++;
        })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    },
  },
};
</script>

<style scoped>
@import "../../reports/reports.css";
.sector-select { min-width: 220px; max-width: 420px; font-size: 0.85rem; }
</style>
